<template>
  <b-modal
    centered
    id="init-appendix"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Yêu cầu hỗ trợ lên phụ lục</h5>
      <b-button size="sm" variant="light" @click="closeModalRequestDevice()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo" class="m-3">
      <div class="form-group">
        <b-form-checkbox v-model="selectedOption" :value="infoSale.userId">
          <p>NVKD phụ trách merchant:</p>
          <p v-if="infoSale">{{ infoSale.name }} - {{ infoSale.email }}</p>
        </b-form-checkbox>
      </div>
      <div class="form-group">
        <b-form-checkbox v-model="selectedOption" value="OTHER">
          <p>User khác</p>
        </b-form-checkbox>
      </div>
      <div class="form-group" v-if="selectedOption === 'OTHER'">
        <Select2 v-model="userId" :options="dataOption" placeholder="Chọn user" />
      </div>
    </form>
    <template #modal-footer>
      <b-button
        class="btn-style"
        size="sm"
        type="button"
        variant="light"
        @click="closeModalRequestDevice()"
      >
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  export default {
    name: 'modal-init-appendix',
    props: {
      infoSale: {
        type: Object,
        default: {},
      },
      dataOption: {
        type: Array,
        default: [],
      },
      closeModalRequestDevice: {
        type: Function,
      },
    },
    data() {
      return {
        showLoading: false,
        selectedOption: null,
        userId: '',
      }
    },
    methods: {
      async updateInfo() {
        let data
        if (this.selectedOption === 'OTHER') {
          data = this.userId
        } else data = this.infoSale.userId
        this.$emit('updateInfo', data)
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
  p {
    font-size: 14px;
  }
</style>
